(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["adorn-denim-home"] && !Shopify.designMode) return;
  try {
    
const adornRoot = document.querySelector('.adorn-launch');
const adornHeader = document.querySelector('#header');
if (adornRoot && adornHeader) {
  const syncAdornHeader = () => {
    const height = getComputedStyle(adornHeader).position === 'fixed' ? adornHeader.getBoundingClientRect().height : 0;
    adornRoot.style.setProperty('--adorn-mobile-header-height', height + 'px');
  };
  new ResizeObserver(syncAdornHeader).observe(adornHeader);
  window.addEventListener('resize', syncAdornHeader);
  syncAdornHeader();
}

  } catch(e) { console.error(e); }
})();
})();
